module.exports = __webpack_public_path__ + "static/media/featured-image.76ef597b.webp";